import LocationLayout from './LocationLayout';
import { P, H2b, UL, LI } from '../content/Typography';
import { locations } from './locations';

const meta = locations.find((l) => l.slug === 'metal-fabrication-toronto');

export default function Toronto() {
  return (
    <LocationLayout title={meta.title} description={meta.description} heading={meta.heading}>
      <H2b>Toronto's fabrication landscape</H2b>
      <P>
        Toronto's metal fabrication capacity is spread across a handful of distinct industrial corridors, each with its own character. Along the Lakeshore,
        older industrial buildings house established welding and structural shops that have served the city's construction trade for decades. Etobicoke's
        industrial parks are dense with sheet metal fabricators and HVAC specialists, many of them set up to turn around ductwork, fittings, and enclosures
        quickly. Scarborough rounds out the picture with a mix of smaller general-purpose job shops — flexible operations well suited to one-off parts and
        short-run production that larger shops elsewhere in the city might not prioritize.
      </P>
      <P>
        The result is a fragmented but capable market: the right shop for your project almost certainly exists somewhere in the city, but finding it by
        cold-calling shops across three or four different corridors is a slow, frustrating way to source a part.
      </P>

      <H2b>Industries we serve in Toronto</H2b>
      <P>
        MetalMatch's Toronto network covers a broad range of clients, each with different fabrication needs:
      </P>
      <UL>
        <LI><strong>Restaurants and hospitality businesses</strong> — custom stainless steel shelving, prep tables, and equipment fixtures built to commercial food-service standards.</LI>
        <LI><strong>HVAC contractors</strong> — custom ductwork transitions, brackets, and fittings for jobs where off-the-shelf components do not fit.</LI>
        <LI><strong>Construction companies</strong> — structural brackets, site fixtures, and custom hardware for active projects across the city.</LI>
        <LI><strong>Product developers and inventors</strong> — first-run prototypes and small-batch production for hardware products headquartered in the city's growing tech and design scene.</LI>
      </UL>

      <H2b>How MetalMatch works for Toronto projects</H2b>
      <P>
        Instead of contacting individual shops across the Lakeshore, Etobicoke, and Scarborough corridors one by one, you submit a single sketch or photo of
        the part you need. Our team turns it into a structured brief with concept renderings, and routes it to two or three Toronto-area fabricators whose
        capability actually matches your project — whether that means a Lakeshore welding shop for a structural bracket, or an Etobicoke sheet metal
        specialist for a custom enclosure. You review comparable quotes side by side and choose the fabricator that fits your timeline and budget, without
        having to know which corner of the city to look in first.
      </P>
      <P>
        Because Toronto's shop base is so spread out, timelines can vary as much by location as by the part itself — a job that takes a week at an
        Etobicoke sheet metal shop might sit in a queue twice as long downtown. Matching your brief to a fabricator with actual capacity, not just
        capability, is a big part of what keeps Toronto projects moving on schedule.
      </P>
    </LocationLayout>
  );
}
